import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { postData } from '../../../services';
import { useState } from 'react';
import Modal from '../../helpers/Modal';
const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

export const DrawingReviewAlertForm = ({ project }) => {
    const { token, base_url } = useAppContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const trimmed = email.trim();
        if (!trimmed) {
            window.showAlert(400, 'Please enter an email address.');
            return;
        }
        if (!isValidEmail(trimmed)) {
            window.showAlert(400, 'Please enter a valid email address.');
            return;
        }

        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const url = `${base_url}/apis/alerts/drawing-review/${encodeURIComponent(trimmed)}/${project.id}`;
            const response = await postData(token, url, {});

            if (!response) {
                window.showAlert(500, 'Failed to send drawing review. Please try again.');
                return;
            }

            if (response.msg) {
                window.showAlert(200, response.msg);
                setEmail('');
                setIsModalOpen(false);
            } else if (response.detail) {
                window.showAlert(400, typeof response.detail === 'string' ? response.detail : 'Unable to send drawing review.');
            } else {
                window.showAlert(400, 'Unable to send drawing review. Please try again.');
            }
        } catch (error) {
            console.error('Error sending drawing review alert:', error);
            window.showAlert(500, 'Failed to send drawing review. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const drawingReviewAlertForm = (
        <div>
            <h2>Send Drawing Review</h2>
            <p>Send a drawing review notification email to a single recipient for this project.</p>
            <p><strong>Project: {project?.project_name}</strong></p>

            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="drawingReviewAlertEmail" className="form-label">
                        Recipient email
                    </label>
                    <input
                        id="drawingReviewAlertEmail"
                        type="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="form-control"
                        placeholder="name@example.com"
                        autoComplete="email"
                        required
                    />
                </div>

                <div className="form-actions">
                    <button
                        type="button"
                        onClick={() => setIsModalOpen(false)}
                        className="btn btn-secondary"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <>
                                <FontAwesomeIcon icon={faSpinner} spin /> Sending...
                            </>
                        ) : (
                            'Send drawing review'
                        )}
                    </button>
                </div>
            </form>
        </div>
    );

    return (
        <>
            <button
                type="button"
                onClick={() => setIsModalOpen(true)}
                className="btn btn-secondary"
                title="Send Drawing Review"
            >
                <FontAwesomeIcon icon={faClipboardCheck} />
                &nbsp;drawing review
            </button>
            {isModalOpen && (
                <Modal form={drawingReviewAlertForm} setIsModalOpen={setIsModalOpen} />
            )}
        </>
    );
};
